import { gql, useQuery } from '@apollo/client';
import { Stack } from '@chakra-ui/react';
import { useRouter } from 'next/router';
import * as React from 'react';

import { Loading } from '@/imports/ui/chakra/components/Loading';
import { OnboardingChecklist } from '@/imports/ui/components/OnboardingChecklist';
import { Vanilla, VanillaAside, VanillaMain } from '@/layouts/Vanilla';

import {
  GroupPageLayout_groupQuery,
  GroupPageLayout_groupQueryVariables,
} from './graphql-types/GroupPageLayout_groupQuery';

import { NoAccessComponent } from '../../imports/ui/components/NoAccess/NoAccessComponent';
import { GroupHeader } from './GroupHeader';

const GROUP_QUERY = gql`
  query GroupPageLayout_groupQuery($input: GroupInput!) {
    group(input: $input) {
      result {
        _id
        settings {
          isAutomated
        }
        ...GroupHeader_GroupFragment
      }
    }
  }
  ${GroupHeader.groupFragment}
`;

export const GroupPageLayout: React.FC = (props) => {
  const router = useRouter();
  const { groupId } = router.query;

  const { error, loading, data } = useQuery<
    GroupPageLayout_groupQuery,
    GroupPageLayout_groupQueryVariables
  >(GROUP_QUERY, {
    variables: {
      input: {
        _id: groupId.toString(),
      },
    },
  });

  return (
    <Vanilla>
      <VanillaMain>
        {loading ? (
          <Loading />
        ) : error ? (
          <NoAccessComponent />
        ) : !data?.group.result ? (
          <NoAccessComponent />
        ) : (
          <Stack spacing="4">
            <GroupHeader group={data.group.result} />
            {props.children}
          </Stack>
        )}
      </VanillaMain>
      <VanillaAside>
        <OnboardingChecklist />
      </VanillaAside>
    </Vanilla>
  );
};
